import React from "react";
import {ColumnLayout, Input, Select} from "@amzn/awsui-components-react";

export class SpecialVTTrueUpCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    return <ColumnLayout columns={3}>
      <div data-awsui-column-layout-root="true">
        <div style={{marginTop: "25px"}}>
          Select base and markup sources to be processed and sent to VT
        </div>
        <div>
          Base Source:
          <Select options={this.props.sources.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.source0,
                    id: this.props.data.source0
                  }}
                  onChange={(e) => this.handleChange('source0', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Markup source:
          <Select options={this.props.sources.map((x) => {
            return {label: x, id: x};
          })}
                  selectedOption={{
                    label: this.props.data.source1,
                    id: this.props.data.source1
                  }}
                  onChange={(e) => this.handleChange('source1', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
